import { chef } from 'cookery';
import fieldBaseTpl from '../base';
import './styles';

const fieldCheckBoxTpl = (initData = {}) => {
    const { cls } = initData;
    return fieldBaseTpl({ ...initData, cls: cls ? cls : 'ck-field-checkbox' });
}

export { fieldCheckBoxTpl }